/**
 * Trunnion AI - Data Flow Edge
 * Animated edge showing classification level.
 */

import { memo } from 'react';
import { BaseEdge, getBezierPath, type EdgeProps } from '@xyflow/react';
import type { WorkflowEdgeData } from '@/types';
import { getClassificationColor } from '@/lib/classification';

export const DataFlowEdge = memo(function DataFlowEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  selected,
}: EdgeProps & { data?: WorkflowEdgeData }) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const color = data?.classification
    ? getClassificationColor(data.classification)
    : '#D4A017';

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: selected ? '#FFCC33' : color,
          strokeWidth: selected ? 3 : 2,
          filter: selected ? 'drop-shadow(0 0 6px rgba(212,160,23,0.5))' : undefined,
        }}
      />
      {/* Animated dash */}
      <path
        d={edgePath}
        fill="none"
        stroke={color}
        strokeWidth={2}
        strokeDasharray="6 4"
        strokeDashoffset={0}
        opacity={0.5}
      >
        <animate
          attributeName="stroke-dashoffset"
          values="0;-20"
          dur="1s"
          repeatCount="indefinite"
        />
      </path>
    </>
  );
});
